/*
 * Consultant Layout component is a parent component for all consultant pages
 */

import React from 'react'
import CustomNavBar from 'components/navigation/navBar'
import ConsultantFooter from '../components/footer'

class ConsultantLayout extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <>
        <CustomNavBar></CustomNavBar>
        <main className="main">{this.props.children}</main>
        <ConsultantFooter />
      </>
    )
  }
}

export default ConsultantLayout
